export const FEATURE_IDS = {
    ORDERS_LIMIT: 'monthly_orders',
    SURVEYS_LIMIT: 'active_surveys',
    SURVEY_RESPONSES : 'survey_responses',
    QUESTIONS_LIMIT: 'questions_per_survey',
    PREMIUM_QUESTIONS: 'all_question_types',
    REMOVE_BRANDING: 'remove_branding',
    ADVANCED_REPORTING: 'advanced_analytics',
    AUDIENCE_TARGETING: 'advanced_survey_targeting',
    RESPONSES_PER_SURVEY: 'responses_per_survey',
    CUSTOM_FEATURES: 'custom_features',
    THIRD_PARTY_INTEGRATIONS: 'third_party_integrations',
    CSV_DOWNLOAD: 'download_survey_reports',
    NPS_TAB: 'nps_tab'
} as const

type FeatureId = (typeof FEATURE_IDS)[keyof typeof FEATURE_IDS]

export const FEATURE_UPGRADE_MESSAGES = {
    [FEATURE_IDS.CSV_DOWNLOAD]: {
        title: 'Export to CSV',
        description: 'Upgrade to export your survey responses to CSV format',
        upgradeButtonText: 'Upgrade now',
    },
    [FEATURE_IDS.ORDERS_LIMIT]: {
        title: 'Unlimited Orders',
        description: 'Upgrade to process unlimited orders',
        upgradeButtonText: 'Upgrade now',
    },
    [FEATURE_IDS.SURVEYS_LIMIT]: {
        title: 'Publish unlimited surveys with Compra Pro! 🥳',
        description:
            'Upgrade to our Pro plan to get full access with advanced features',
        upgradeButtonText: 'Upgrade now',
    },
    [FEATURE_IDS.CUSTOM_FEATURES]: {
        title: 'Advanced Features',
        description: 'Upgrade to access advanced survey features',
        upgradeButtonText: 'Upgrade now',
    },
    [FEATURE_IDS.QUESTIONS_LIMIT]: {
        title: 'Unlock more with Compra Pro! 🥳',
        description:
            'Upgrade to our Pro plan to get full access with advanced features',
        upgradeButtonText: 'Upgrade now',
    },
    [FEATURE_IDS.REMOVE_BRANDING]: {
        title: 'Remove Branding',
        description: 'Upgrade to remove Compra branding from your surveys',
        upgradeButtonText: 'Upgrade now',
    },
    [FEATURE_IDS.ADVANCED_REPORTING]: {
        title: 'Advanced Analytics',
        description: 'Upgrade to access advanced analytics and reporting',
        upgradeButtonText: 'Upgrade now',
    },
    [FEATURE_IDS.AUDIENCE_TARGETING]: {
        title: 'Audience Targeting',
        description: 'Upgrade to target specific audiences for your surveys',
        upgradeButtonText: 'Upgrade now',
    },
    [FEATURE_IDS.RESPONSES_PER_SURVEY]: {
        title: 'Unlimited Responses',
        description: 'Upgrade to collect unlimited responses per survey',
        upgradeButtonText: 'Upgrade now',
    },
    [FEATURE_IDS.THIRD_PARTY_INTEGRATIONS]: {
        title: 'Third-Party Integrations',
        description: 'Upgrade to integrate with third-party tools',
        upgradeButtonText: 'Upgrade now',
    },
    [FEATURE_IDS.PREMIUM_QUESTIONS]: {
        title: 'Premium Questions',
        description: 'Upgrade to access premium questions',
        upgradeButtonText: 'Upgrade now',
    },
} as const

export const FEATURE_LIMITS = {
    [FEATURE_IDS.ORDERS_LIMIT]: {
        free: 1000,
        starter: null, // unlimited
    },
    [FEATURE_IDS.SURVEYS_LIMIT]: {
        free: 3,
        starter: -1, // unlimited
    },
    [FEATURE_IDS.QUESTIONS_LIMIT]: {
        free: 3,
        starter: -1, // unlimited
    },
} as const

export const getFeatureUpgradeMessage = (featureId: FeatureId) => {
    return FEATURE_UPGRADE_MESSAGES[featureId]
}

export const getFeatureLimit = (
    featureId: keyof typeof FEATURE_LIMITS,
    planTier: number
) => {
    const limits = FEATURE_LIMITS[featureId]
    return planTier === 1 ? limits.free : limits.starter
}
